import { useState } from "react";
import { Target, Check } from "lucide-react";
import {
  Popover,
  PopoverTrigger,
  PopoverContent,
} from "../../../../components/UI/Popover";
import { cn } from "../../../../utils/utils";

/**
 * Dropdown to assign / change / clear a contact's pipeline stage.
 * Shows current stage as a colored pill in the trigger.
 */
const PipelineStageSelector = ({
  stages = [],
  currentStageId,
  onChange,
  disabled = false,
}) => {
  const [open, setOpen] = useState(false);
  const current = stages.find((s) => (s._id || s.id) === currentStageId);

  const handlePick = (stageId) => {
    onChange?.(stageId === currentStageId ? null : stageId);
    setOpen(false);
  };

  return (
    <Popover open={open} onOpenChange={setOpen}>
      <PopoverTrigger asChild>
        <button
          disabled={disabled}
          className={cn(
            "inline-flex items-center gap-1 h-7 px-2 rounded-md border text-[12px] font-medium transition-colors",
            current
              ? "border-gray-200 bg-white hover:bg-gray-50"
              : "border-dashed border-gray-300 bg-white text-gray-500 hover:bg-gray-50",
            disabled && "opacity-50 cursor-not-allowed",
          )}
          title="Chọn giai đoạn bán hàng"
        >
          <Target size={12} />
          {current ? (
            <span
              className="inline-flex items-center gap-1"
              style={{ color: current.color || "#374151" }}
            >
              <span
                className="w-2 h-2 rounded-full"
                style={{ backgroundColor: current.color || "#9ca3af" }}
              />
              {current.name}
            </span>
          ) : (
            <span>Giai đoạn</span>
          )}
        </button>
      </PopoverTrigger>
      <PopoverContent
        className="w-52 p-1.5 bg-white"
        side="bottom"
        align="start"
      >
        <div className="space-y-0.5">
          <div className="text-[11px] font-semibold uppercase tracking-wide text-gray-500 px-1.5 py-1">
            Giai đoạn bán hàng
          </div>
          {stages.length === 0 && (
            <div className="px-2 py-2 text-[12px] text-gray-500">
              Chưa có giai đoạn nào
            </div>
          )}
          {stages.map((s) => {
            const id = s._id || s.id;
            const active = id === currentStageId;
            return (
              <button
                key={id}
                onClick={() => handlePick(id)}
                className={cn(
                  "w-full flex items-center justify-between px-2 py-1.5 rounded-md text-[12px] transition-colors hover:bg-gray-100",
                  active && "bg-gray-50",
                )}
              >
                <span className="inline-flex items-center gap-2">
                  <span
                    className="w-2.5 h-2.5 rounded-full"
                    style={{ backgroundColor: s.color || "#9ca3af" }}
                  />
                  {s.name}
                </span>
                {active && <Check size={14} className="text-primary" />}
              </button>
            );
          })}
          {currentStageId && (
            <button
              onClick={() => {
                onChange?.(null);
                setOpen(false);
              }}
              className="w-full text-left px-2 py-1.5 mt-1 rounded-md text-[12px] text-gray-500 hover:bg-gray-50 border-t border-gray-100"
            >
              Bỏ gắn giai đoạn
            </button>
          )}
        </div>
      </PopoverContent>
    </Popover>
  );
};

export default PipelineStageSelector;
